exports = module.exports = require("../../../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".classificationMainView{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}._2gsdfRdgPufGKACA3VswH2{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;background-color:#f5f8fa;margin-top:1rem;margin-left:-1.5rem;margin-right:-1.5rem;margin-bottom:-1.5rem;padding:1rem 1.5rem}._2gsdfRdgPufGKACA3VswH2 .ico{margin-right:1rem}\n", ""]);

// exports
exports.locals = {
	"canNotEditContainer": "_2gsdfRdgPufGKACA3VswH2"
};